module.exports = "<vb-touch-menu\r\n  [menuEntries]=\"activeEntries$ | async\">\r\n</vb-touch-menu>"


//////////////////
// WEBPACK FOOTER
// ./src/app/visbos-touch-client/ui/navigation/touch-navigation-menu/touch-navigation-menu.component.html
// module id = ./src/app/visbos-touch-client/ui/navigation/touch-navigation-menu/touch-navigation-menu.component.html
// module chunks = main